import { render, staticRenderFns } from "./goods_grid.vue?vue&type=template&id=4a4ea094&scoped=true"
import script from "./goods_grid.vue?vue&type=script&lang=js"
export * from "./goods_grid.vue?vue&type=script&lang=js"
import style0 from "./goods_grid.vue?vue&type=style&index=0&id=4a4ea094&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4ea094",
  null
  
)

export default component.exports